/**
 * Texto legível de atendimentos para o prompt (evita a IA misturar com negociações).
 */

import type { ChatStats } from './salesAnalysis';

function formatOriginLines(origemDasConversas: Record<string, number>): string {
    const entries = Object.entries(origemDasConversas).sort((a, b) => b[1] - a[1]);
    if (!entries.length) return '- (sem dados de origem nas conversas)';
    return entries.map(([name, count]) => `- ${name}: ${count}`).join('\n');
}

function formatAgentLines(
    conversationsByAgent: { agentName: string; count: number }[]
): string {
    if (!conversationsByAgent.length) return '- (sem responsáveis atribuídos)';
    return conversationsByAgent
        .slice(0, 8)
        .map((a) => `- ${a.agentName}: ${a.count}`)
        .join('\n');
}

/** Bloco em português para o prompt — total e origem das conversas ficam explícitos. */
export function formatChatStatsForPrompt(stats: ChatStats): string {
    const mediana =
        stats.tempoMedianoPrimeiraRespostaMinutos == null
            ? 'sem dados suficientes'
            : `${stats.tempoMedianoPrimeiraRespostaMinutos} minutos`;
    const pct15 =
        stats.pctRespondidasEmAte15Min == null
            ? 'sem dados suficientes'
            : `${stats.pctRespondidasEmAte15Min}%`;

    return `
TOTAL DE CONVERSAS: ${stats.totalConversations}
- Abertas: ${stats.openConversations}
- Fechadas: ${stats.closedConversations}
- Sem responsável: ${stats.unassignedConversations}

ORIGEM DAS CONVERSAS (não confundir com origem das negociações):
${formatOriginLines(stats.origemDasConversas)}

VELOCIDADE DE ATENDIMENTO:
- Tempo mediano até a equipe iniciar: ${mediana}
- Respondidas em até 15 minutos: ${pct15}
- Conversas sem resposta da equipe: ${stats.conversasSemRespostaDaEquipe}

VOLUME POR ATENDENTE:
${formatAgentLines(stats.conversationsByAgent)}
`.trim();
}
